export default [

     {
          path: '/milestone',
          name: 'Milestone',
          component: () => import("@/views/Page/StrategicPlan/Milestone/Milestone.vue"),
           meta: {
               title: 'Milestone',
          },
     }
];